import { Box, Button, styled, Typography } from '@mui/material';

import { Colors } from '../../../../utils/Colors';

export const Container = styled(Box)`
    background-color: ${Colors.tealishBlue};
    height: 500px;
    width: 100%;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const TaskCompletedImage = {
    borderRadius: '15px',
    width: '400px'
};

export const DoneButton = styled(Button)<{ component?: React.ElementType, to?: string }>`
    height: 42px;
    width: 126px;
    background: linear-gradient(105.23deg, #FABB18 0%, #C48E02 100%);
`;

export const TaskCompletedText = styled(Typography)`
    color: ${Colors.white90};
    margin-top: 20px;
`;
